import computed from './computed'
import data from './data'

export default {
  computed,
  data,
  resourcePath: 'v1/professional/companies/employees'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/resources/index.js